<style>
  .quill-editor:not(.bubble) .ql-container,
  .quill-editor:not(.bubble) .ql-container .ql-editor {
    height: 30rem;
    padding-bottom: 1rem;
  }
  .quillWrapper .ql-editor{height:500px;}
  .ql-snow .ql-picker-label:before{
    vertical-align: top
  }
  .ivu-table-wrapper .ivu-card-body{
    padding: 10px;
    font-size: 12px;
    line-height: 24px;
  }
</style>
<style scoped>
  .upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .upload-list img{
        width: 100%;
        height: 100%;
    }
    .upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .upload-list:hover .upload-list-cover{
        display: block;
    }
    .upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>
<template>
  <div>
  <Form ref="documentForm" :model="formItem" label-position="top" :rules="ruleData" class="documents-form">
    <Tabs :animated="false" class="doc-tabs" value="base">
      <TabPane label="基本信息" name="base">
        <Row>
          <Col :xs="24" :sm="16">
            <FormItem label="供应商" prop="supplier">
              <Tag v-for="(item,index) in supplier" :key="index">{{item}}</Tag> <Button size="small" href="javascript:void(0)" @click="supplierModal=true">请选择</Button>
            </FormItem>
            <FormItem label="商品名称：" prop="title">
              <Input v-model="formItem.title"></Input>
            </FormItem>
            <FormItem label="商品简介：" prop="description">
              <Input v-model="formItem.description" type="textarea"></Input>
            </FormItem>
            <FormItem label="金额：" prop="price">
              <Input v-model="formItem.price" :disabled="priceDisabled" style="width:200px;float:left;margin-right: 10px">
                <span slot="append">￥</span>
              </Input>
              <!-- <Input v-model="formItem.price" style="width:200px;float:left">
                <span slot="prepend">原价：</span>
              </Input> -->
            </FormItem>
            <FormItem label="园区价：" prop="park_price">
              <Input v-model="formItem.park_price" :disabled="priceDisabled" style="width:200px;float:left;margin-right: 10px">
                <span slot="append">￥</span>
              </Input>
              <!-- <Input v-model="formItem.price" style="width:200px;float:left">
                <span slot="prepend">原价：</span>
              </Input> -->
            </FormItem>
            <FormItem label="积分返还比例：" prop="park_price">
              <Input v-model="formItem.integral" style="width:200px;float:left;margin-right: 10px">
              </Input>
              <p style="line-height: 22px;display:block"><Tag style="display:inline-block;vertical-align: top;margin:0"><Icon type="information-circled"></Icon> 如：产品价格100元，返现10元 则 10/100=0.1 填 0.1</Tag></p>
            </FormItem>
            <FormItem label="重量：">
              <Input v-model="formItem.weight" style="width:200px;margin-bottom:10px;">
                <span slot="append">千克(kg)</span>
              </Input>
              <p style="line-height: 22px"><Tag style="display:inline-block;vertical-align: top;margin:0"><Icon type="information-circled"></Icon> 请输入商品的重量单位为 千克（g）,如果商品有多个规格，以规格重量为准。</Tag></p>
            </FormItem>
            <FormItem label="运费：">
              <Input v-model="formItem.freight" style="width:200px;margin-bottom:10px;">
                <span slot="append">千克(kg)</span>
              </Input>
              <p style="line-height: 22px"><Tag style="display:inline-block;vertical-align: top;margin:0"><Icon type="information-circled"></Icon> 请输入商品每 千克（g）价格，0 表示包邮。</Tag></p>
            </FormItem>
          </Col>
          <Col :xs="0" :sm="1">&nbsp;</Col>
          <Col :xs="24" :sm="7">
            <FormItem label="商品封面：" prop="cover_id">
              <template v-for="(item, ind) in coverFile">
              <div class="upload-list" v-if="coverFile.length>0" :key="ind" style="width: 180px;height:180px;">
                  <template v-if="item.status === 'finished'">
                      <img :src="item.url">
                      <div class="upload-list-cover" style="line-height: 180px">
                          <Icon type="ios-eye-outline" size="30" style="margin:0 10px" @click.native="handleView(item.url)"></Icon>
                          <Icon type="ios-trash-outline" size="30" style="margin:0 10px" @click.native="handleCoverRemove(item)"></Icon>
                      </div>
                  </template>
                  <template v-else>
                      <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                  </template>
              </div>
              </template>
              <Upload
                  ref="coverUpload"
                  :show-upload-list="false"
                  :default-file-list="coverFileList"
                  :on-success="handleCoverSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  type="drag"
                  :data="{file_type:'cover_file'}"
                  :headers="uploadHeaders"
                  :action="uploadApiPath"
                  v-show="coverFile.length==0"
                  style="display: inline-block;width:180px;">
                  <div style="width: 180px;height:180px; line-height: 180px">
                      <Icon type="image" size="60" color="#999"></Icon>
                  </div>
              </Upload>
            </FormItem>
            <FormItem label="轮播图：">
              <div class="upload-list" v-for="(item, ind) in uploadList" :key="ind">
                <template v-if="item.status === 'finished'">
                    <img :src="item.url">
                    <div class="upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                    </div>
                </template>
                <template v-else>
                    <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                </template>
              </div>
              <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  multiple
                  type="drag"
                  :data="{file_type:'document_file'}"
                  :headers="uploadHeaders"
                  :action="uploadApiPath"
                  v-show="uploadList.length<4"
                  style="display: inline-block;width:58px;">
                  <div style="width: 58px;height:58px;line-height: 58px;">
                      <Icon type="images" size="20" color="#999"></Icon>
                  </div>
              </Upload>
            </FormItem>
          </Col>
        </Row>
          <FormItem label="商品详情：" prop="content">
            <!-- <quill-editor ref="myQuillEditor" :options="editorOption" v-model="formItem.content"></quill-editor> -->
            <!-- <Upload
                ref="editorUpload"
                class="editor-upload"
                :show-upload-list="false"
                :on-success="handleEditorSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="520"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                multiple
                :data="{file_type:'editor_upload'}"
                :headers="uploadHeaders"
                style="height:0"
                :action="uploadApiPath">
            </Upload> -->
          </FormItem>
          <FormItem label="总库存：">
          <Input v-model="formItem.total_stock" style="width:100px;margin-bottom:10px" placeholder="浏览量"></Input>
            <p style="line-height: 22px"><Tag style="display:inline-block;vertical-align: top;margin:0"><Icon type="information-circled"></Icon> 总库存为 0 时，会上架到『已售罄的商品』列表里 发布后商品同步更新，以库存数字为准。</Tag></p>

        </FormItem>
      </TabPane>
      <TabPane label="库存/规格">
        <FormItem label="库存/规格：">
          <div class="sku">
            <div>
              <Card  v-for="(item, ind) in sku.type" :key="ind" style="margin-bottom:10px;">
                <Poptip
                  confirm
                  title="确定要删除该规格吗？"
                  width="180"
                  @on-ok="delType(ind)" style="float:right">
                  <Button type="text" style="border-left:1px solid #eee" long><Icon type="close" size="18"></Icon></Button>
                </Poptip>
                <p >
                  <label style="float:left;font-size: 12px;">{{item}}：</label>
                  <template v-for="(attr, k) in sku.attr[ind]">
                  <Input v-if="sku.attr[ind].length > 0" :key="k" v-model="attr.name" @on-blur="attrBlur(ind)" style="float:left;margin-right:10px;width:140px;" placeholder="项目名称">
                    <Button :key="'button_'+k" :icon="k==0?'refresh':'close-round'" slot="append" @click="handleClose(sku.attr[ind], k)"></Button>
                  </Input>
                  </template>
                    <Button icon="ios-plus-empty" type="dashed" @click="handleAdd(ind)">增加</Button>
                    <!-- <div class="api" slot="content">
                      <Input v-model="attrInp" style="margin-bottom:1px" placeholder="请输入属性名称">
                        <Button slot="append" @click.stop="">确定</Button>
                      </Input>
                    </div> -->
                </p>
              </Card>
              <div style="width:330px;border:1px dotted #ddd;position:relative;border-radius:6px;padding:10px">
                <span style="">添加规格：</span>
                <Input placeholder="规格名称" style="display:inline-block;width:180px" v-model="typeInp">
                </Input>
                <Button style="display:inline-block;width:60px;font-size:26px;border-width:0 0 0 1px;border-radius:0;border-style:dotted;height:100%;position: absolute;top:0;right:0" :disabled="!typeInp" icon="plus" @click.stop="handleTypeAdd"></Button>
              </div>
            </div>
          </div>
        </FormItem>
        <FormItem label="库存/价格：">
          <div class="ivu-table-wrapper">
            <div class="ivu-table ivu-table-border">
              <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
                <thead class="ivu-table-header">
                  <tr>
                    <th v-for="(item, ind) in sku.type" :key="ind">
                      <div class="ivu-table-cell">{{item}}</div>
                    </th>
                    <th><div class="ivu-table-cell">价格</div></th>
                    <th><div class="ivu-table-cell">园区价</div></th>
                    <th><div class="ivu-table-cell">库存</div></th>
                    <th><div class="ivu-table-cell">重量</div></th>
                  </tr>
                </thead>
                <tbody class="ivu-table-body">
                  <tr v-for="(item, ind) in result" :key="ind">
                    <td v-for="(val, i) in item.name" :key="i">
                      <div class="ivu-table-cell">{{val.name}}</div>
                    </td>
                    <td>
                      <div class="ivu-table-cell">
                        <Input v-model="item.price" @on-change="handleDataChange" number placeholder="价格"></Input>
                      </div>
                    </td>
                    <td>
                      <div class="ivu-table-cell">
                        <Input v-model="item.park_price" @on-change="handleDataChange" number placeholder="价格"></Input>
                      </div>
                    </td>
                    <td>
                      <div class="ivu-table-cell">
                        <Input v-model="item.stock" @on-change="handleDataChange" number placeholder="库存"></Input>
                      </div>
                    </td>
                    <td>
                      <div class="ivu-table-cell">
                        <Input v-model="item.weight" placeholder="重量" style="margin-bottom:1px"><span slot="append">kg</span></Input>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Card style="background: #f7f7f7;">
                批量设置:
                  <Poptip placement="top" width="200">
                    <Button icon="edit" size="small">价格</Button>
                    <div class="api" slot="content" style="padding: 5px 0">
                      <Input style="margin-bottom:2px;" v-model="priceInp" placeholder="请输入价格">
                        <Button slot="append" size="small" @click.stop="addValue('price')">确定</Button>
                      </Input>
                    </div>
                  </Poptip>
                  <Poptip placement="top" width="200">
                    <Button icon="edit" size="small">园区价</Button>
                    <div class="api" slot="content" style="padding: 5px 0">
                      <Input style="margin-bottom:2px;" v-model="stockInp" placeholder="请输入库存">
                        <Button slot="append" size="small" @click.stop="addValue('park_price')">确定</Button>
                      </Input>
                    </div>
                  </Poptip>
                  &nbsp;
                  &nbsp;
                  <Poptip placement="top" width="200">
                    <Button icon="edit" size="small">库存</Button>
                    <div class="api" slot="content" style="padding: 5px 0">
                      <Input style="margin-bottom:2px;" v-model="stockInp" placeholder="请输入库存">
                        <Button slot="append" size="small" @click.stop="addValue('stock')">确定</Button>
                      </Input>
                    </div>
                  </Poptip>
                  &nbsp;
                  <Poptip placement="top" width="200">
                    <Button icon="edit" size="small">重量(件/kg)</Button>
                    <div class="api" slot="content" style="padding: 5px 0">
                      <Input style="margin-bottom:2px;" v-model="weightInp" placeholder="请输入重量(件/kg)">
                        <Button slot="append" size="small" @click.stop="addValue('weight')">确定</Button>
                      </Input>
                    </div>
                  </Poptip>
              </Card>
            </div>
          </div>
        </FormItem>
      </TabPane>
      <TabPane label="其他设置">
        <FormItem label="推荐位：">
          <CheckboxGroup v-model="formItem.position">
            <Checkbox label="home">首页推荐</Checkbox>
          </CheckBoxGroup>
        </FormItem>
        <FormItem label="限购：">
          <Input v-model="formItem.quota" style="width:100px;margin-bottom:10px;" placeholder="浏览量"></Input>
          <p style="line-height: 22px"><Tag style="display:inline-block;vertical-align: top;margin:0"><Icon type="information-circled"></Icon> 0 代表不限购</Tag></p>
        </FormItem>
        <FormItem label="发票">
          <RadioGroup v-model="formItem.invoice">
            <Radio label="0">无</Radio>
            <Radio label="1">有</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="保修：">
          <RadioGroup v-model="formItem.warranty">
            <Radio label="0">无</Radio>
            <Radio label="1">有</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="浏览量：">
          <Input v-model="formItem.view" style="width:100px;" placeholder="浏览量"></Input>
        </FormItem>
        <FormItem label="优先级：">
          <Input v-model="formItem.sort_id" style="width:100px;margin-bottom:10px;" placeholder="优先级"></Input>
          <p style="line-height: 22px"><Tag style="display:inline-block;vertical-align: top;margin:0"><Icon type="information-circled"></Icon> 越高排序越靠前</Tag></p>
        </FormItem>
      </TabPane>
    </Tabs>
      <FormItem label="">
        <Button type="primary" @click="submitDocument" long>{{id==0?'提交':'修改'}}</Button>
      </FormItem>
    </Form>
    <Modal title="查看图片" v-model="visible">
        <img :src="imgName" v-if="visible" style="width: 100%">
    </Modal>
    <Modal
        v-model="supplierModal"
        title="选择供应商"
        @on-ok="supplierOk">
        <div class="supplier-list">
          <CheckboxGroup v-model="supplier">
            <Checkbox v-for="(item,index) in suppliers" :key="index" :label="item.supplier.company_name"></Checkbox>
          </CheckboxGroup>
        </div>
    </Modal>
    </div>
</template>

<script>
  import {fetch, post, put} from '../fetch/api'
  // require styles
  // import 'quill/dist/quill.core.css'
  // import 'quill/dist/quill.snow.css'
  // import 'quill/dist/quill.bubble.css'

  // import { quillEditor } from 'vue-quill-editor'
  let token = localStorage.getItem('token')

  // 工具栏配置
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction

    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],

    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image', 'video'],
    ['clean']                                         // remove formatting button
  ]

  // const checkPrice = (rule, value, callback) => {
  //   if (!/^([-|1-9][\d]{0,7}|0)(\.[\d]{1,10})?$/.test(value)) {
  //     callback(new Error('金额格式错误！'))
  //   } else {
  //     callback()
  //   }
  // }
  const formData = {
    'title': '',
    'description': null,
    'pics': [],
    'price': null,
    'park_price': null,
    'weight': null,
    'freight': 0,
    'content': '',
    'type': null,
    'position': [],
    'integral': 0,
    'quota': 0,
    'supplier_id': '',
    'invoice': 0,
    'warranty': 0,
    'view': 0,
    'sort_id': 0,
    'cover_id': '',
    'sku': {}
  }

  export default {
    name: 'DocumentPost',
    components: {
      // quillEditor,
      // EditSku: resolve => { require(['./EditSkuComponent'], resolve) }
    },
    props: {
      id: {
        type: Number,
        default:0
      }
    },
    data () {
      return {
        supplier: [],
        suppliers: [],
        formItem: JSON.parse(JSON.stringify(formData)),
        ruleData: {
          title: [
            {required: true, message: '请输入标题', trigger: 'change'}
          ],
          description: [
            {required: true, message: '请输入简介', trigger: 'change'}
          ],
          content: [
            {required: true, message: '请输入商品详情', trigger: 'change'}
          ],
          price: [
            {required: true, message: '请输入金额', trigger: 'change'}
            // {validator: checkPrice, trigger: 'blur'}
          ]
        },
        defaultList: [],
        coverFileList: [],
        supplierModal: false,
        imgName: '',
        visible: false,
        uploadList: [],
        coverFile: [],
        token: token,
        uploadApiPath: '/api/users/upfile',
        uploadHeaders: {
          'Authorization': `Bearer ${token}`
        },
        result: [],
        historyData: {},
        priceDisabled: false,
        attrInp: '',
        typeInp: '',
        priceInp: '',
        stockInp: '',
        weightInp: '',
        sku: {
          type: [],
          attr: [],
          data: [],
          'is_pic': 0
        },
        editorOption: {
          placeholder: '',
          theme: 'snow',  // or 'bubble'
          modules: {
            toolbar: {
              container: toolbarOptions,  // 工具栏
              handlers: {
                'image': function (value) {
                  if (value) {
                    document.querySelector('.editor-upload input').click()
                  } else {
                    this.quill.format('image', false)
                  }
                }
              }
            }
          }
        }
      }
    },
    watch: {
      'sku.attr' () {
        this.result = this.descartes(this.sku.attr)
      },
      'sku.type' () {
        this.result = this.descartes(this.sku.attr)
      },
      id (val) {
        if (val !== 0) {
          this.fetchDocument()
        }
      },
      supplierModal () {
        // if (val) this.fetchSupplier()
      },
      supplier (val) {
        var ids = []
        for (let k in this.suppliers) {
          if (val.indexOf(this.suppliers[k].supplier.company_name) >= 0) ids.push(this.suppliers[k].id)
        }
        this.formItem.supplier_id = ids.join(',')
      }
    },
    methods: {
      fetchDocument () {
        fetch(`goods/${this.id}`).then(res => {
          if (res.status === 'ok') {
            for (let k in res.cover) {
              this.coverFile.push({
                'name': 'image',
                'status': 'finished',
                'id': k,
                'url': this.apiPath + res.cover[k]
              })
            }

            for (let k in res.pics) {
              this.uploadList.push({
                'name': 'image',
                'status': 'finished',
                'id': k,
                'url': this.apiPath + res.pics[k]
              })
            }

            this.makeData(res.result)
          }
        })
      },
      fetchSupplier (cb) {
        fetch('console/suppliers/all').then(res => {
          this.suppliers = res.result
          typeof cb === 'function' && cb(res)
        })
      },
      supplierOk () {
      },
      makeData (res) {
        res.position = res.position.split(',')
        this.formItem = res
        this.sku = JSON.parse(res.sku)
        this.formatSupplier()
        this.setResultData(this.sku.data)
      },
      formatSupplier () {
        this.fetchSupplier(() => {
          let sid = this.formItem.supplier_id.split(',')
          this.supplier = []
          for (let k in this.suppliers) {
            let cname = this.suppliers[k].supplier.company_name
            let id = this.suppliers[k].id
            if (sid.indexOf(id.toString()) >= 0) {
              this.supplier.push(cname)
            }
          }
        })
      },
      attrBlur () {
        // this.sku.attr = this.unique(this.sku.attr[ind])
        this.result = this.descartes(this.sku.attr)
      },
      handleDataChange () {
        this.setResultData(this.result)
      },
      setResultData (result) {
        let minPrice = 0
        let maxPrice = 0
        let minParkPrice = 0
        let maxParkPrice = 0
        let price = 0
        let parkPrice = 0
        let totalStock = 0

        if (result.length === 0) return

        for (let k in result) {
          if (this.historyData[result[k].key] === 'undefined') {
            this.historyData[result[k].key] = {}
          }
          this.historyData[result[k].key] = {'price': result[k].price, 'park_price': result[k].park_price, 'weight': result[k].weight, stock: result[k].stock}
          // 重量体统计
          if (result[k].stock) totalStock = totalStock + Number(result[k].stock)
          // 价格
          if (result[k].price && result[k].price !== undefined) {
            if (minPrice === 0) {
              minPrice = Number(result[k].price)
              maxPrice = Number(result[k].price)
            }

            minPrice = Number(result[k].price) < minPrice ? result[k].price : minPrice
            maxPrice = Number(result[k].price) > maxPrice ? Number(result[k].price) : maxPrice
          }
          // 价格
          if (result[k].park_price && result[k].park_price !== undefined) {
            if (minParkPrice === 0) {
              minParkPrice = Number(result[k].park_price)
              maxParkPrice = Number(result[k].park_price)
            }

            maxParkPrice = Number(result[k].park_price) > maxParkPrice ? Number(result[k].park_price) : maxParkPrice
            minParkPrice = Number(result[k].park_price) < minParkPrice ? result[k].park_price : minParkPrice
          }
          // console.log(minPrice, maxPrice)
        }
        if (minPrice === maxPrice) {
          price = minPrice
        } else {
          price = minPrice + '-' + maxPrice
        }

        if (minParkPrice === maxParkPrice) {
          parkPrice = minParkPrice
        } else {
          parkPrice = minParkPrice + '-' + maxParkPrice
        }

        this.priceDisabled = price !== 0
        this.formItem.price = price
        this.formItem.park_price = parkPrice
        this.formItem.total_stock = totalStock
      },
      handleView (path) {
        this.imgName = path
        this.visible = true
      },
      handleRemove (file) {
        let files = this.$refs.upload.fileList
        files.splice(files.indexOf(file), 1)
        this.setPics()
      },
      handleCoverRemove (file) {
        let files = this.$refs.coverUpload.fileList
        files.splice(files.indexOf(file), 1)
        this.formItem.cover_id = ''
      },
      handleCoverSuccess (res, file) {
        if (res.status === 'ok') {
          file.url = this.apiPath + res.result.file_path
          file.id = res.id
          file.name = res.result.file_path
          this.formItem.cover_id = res.id
        }
      },
      handleSuccess (res, file) {
        if (res.status === 'ok') {
          file.url = this.apiPath + res.result.file_path
          file.id = res.id
          file.name = res.result.file_path
          setTimeout(() => {
            this.setPics()
          }, 600)
        }
      },
      setPics () {
        let fileList = this.$refs.upload.fileList
        let files = []
        for (let k in fileList) {
          files.push(fileList[k].id)
        }
        this.formItem.pics = files.join(',')
      },
      handleEditorSuccess (res) {
        // res为图片服务器返回的数据
        // 获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill
        // 如果上传成功
        if (res.status === 'ok') {
          // 获取光标所在位置
          let length = quill.getSelection().index
          // 插入图片  res.info为服务器返回的图片地址
          quill.insertEmbed(length, 'image', this.apiPath + res.result.file_path)
          // 调整光标到最后
          quill.setSelection(length + 1)
        } else {
          this.$Message.error('图片插入失败')
        }
        // loading动画消失
        this.quillUpdateImg = false
      },
      handleFormatError (file) {
        this.$Notice.warning({
          title: 'The file format is incorrect',
          desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
        })
      },
      handleMaxSize (file) {
        this.$Notice.warning({
          title: 'Exceeding file size limit',
          desc: 'File  ' + file.name + ' is too large, no more than 2M.'
        })
      },
      handleBeforeUpload () {
        const check = this.uploadList.length < 5
        if (!check) {
          this.$Notice.warning({
            title: 'Up to five pictures can be uploaded.'
          })
        }
        return check
      },
      handleTypeAdd () {
        if (!this.typeInp) {
          this.$Message.error('请输入规格名称')
          return false
        }
        if (this.sku.type.indexOf(this.typeInp) === -1) {
          this.sku.type.push(this.typeInp)
          this.sku.attr[this.sku.type.length - 1] = [{name: ''}]
        } else {
          this.$Message.error('属性已存在，不可重复提交')
        }
        this.typeInp = ''
        // console.log(this.sku.type)
        // console.log(this.sku.attr)
      },
      handleAdd (ind) {
        // if (!this.attrInp) {
        //   this.$Message.error('请输入属性名称')
        //   return false
        // }
        let attr = JSON.parse(JSON.stringify(this.sku.attr))
        this.sku.attr = []
        // if (attr[ind].indexOf(this.attrInp) === -1) {
        attr[ind].push({name: ''})
        this.sku.attr = attr
        // } else {
          // this.$Message.error('属性已存在，不可重复提交')
        // }
        this.attrInp = ''
      },
      handleClose (attr, ind) {
        // const index = this.sku.attr.indexOf(name)
        if (ind > 0) {
          attr.splice(ind, 1)
        } else {
          attr[ind].name = ''
        }
      },
      delType (ind) {
        this.sku.type.splice(ind, 1)
        this.sku.attr.splice(ind, 1)
        // console.log(this.sku.type)
        // console.log(this.sku.attr)
      },
      getAttr (ind) {
        if (ind === 0) {
          return this.sku.data
        } else {
          let ch = ''
          for (let i = 0; i < ind; i++) {
            ch += '[0].ch'
          }
          return eval('this.sku.data' + ch)
        }
      },
      addValue (key) {
        for (let k in this.result) {
          this.result[k][key] = this[key + 'Inp']
        }
        this.setResultData(this.result)
      },
      // 笛卡儿积组合
      descartes (list) {
        // parent上一级索引;count指针计数
        let point = {}
        let result = []
        let pIndex = null
        let tempCount = 0
        let temp = []
        // 根据参数列生成指针对象
        for (let index in list) {
          if (typeof list[index] === 'object') {
            point[index] = {'parent': pIndex, 'count': 0}
            pIndex = index
          }
        }
        // 单维度数据结构直接返回
        if (pIndex === null) {
          console.log('return')
          return list
        }
        // 动态生成笛卡尔积
        let v = true
        while (v) {
          console.log(v)
          for (var index in list) {
            tempCount = point[index]['count']
            temp.push(list[index][tempCount])
          }
          let tmpKey = []
          for (let i in temp) {
            tmpKey.push(temp[i].name)
          }
          let key = tmpKey.join('_')
          let price = ''
          let stock = ''
          let weight = ''
          let parkPrice = ''
          if (this.historyData[key]) {
            price = this.historyData[key].price
            parkPrice = this.historyData[key].park_price
            stock = this.historyData[key].stock
            weight = this.historyData[key].weight
          }

          let isUnique = this.isUnique(key, result)
          // 压入结果数组
          if (!isUnique) result.push({key: key, name: temp, price: price, 'park_price': parkPrice, stock: stock, weight: weight})
          temp = []
          // 检查指针最大值问题
          while (v) {
            if (point[index]['count'] + 1 >= list[index].length) {
              point[index]['count'] = 0
              pIndex = point[index]['parent']
              if (pIndex == null) {
                return result
              }
            // 赋值parent进行再次检查
              index = pIndex
            } else {
              point[index]['count'] ++
              break
            }
          }
        }
      },
      isUnique (key, result) {
        let unique = false
        for (let k in result) {
          if (result[k].key === key) {
            unique = true
            break
          }
        }
        return unique
      },
      submitDocument () {
        this.$refs['documentForm'].validate((valid) => {
          if (valid) {
            let data = this.formItem
            let res
            this.sku.data = this.result
            data.sku = JSON.stringify(this.sku)

            if (this.id === 0) {
              res = post(`/goods`, data)
            } else {
              res = put(`/goods/${this.id}`, data)
            }
            res.then(res => {
              if (res.status === 'ok') {
                this.$Message.info({
                  content: res.msg,
                  duration: 5
                })
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 5
                })
              }
            })
            .catch(res => {
              this.$Message.error(res.msg)
            })
          } else {
            this.$Message.error('请确认表单是否填写完整')
          }
        })
      }
    },
    mounted () {
      this.uploadList = this.$refs.upload.fileList
      this.coverFile = this.$refs.coverUpload.fileList
      this.result = this.descartes(this.sku.attr)
      this.fetchSupplier()
      if (this.$route.query.goods_id) {
        this.$emit('update:id', this.$route.query.goods_id)
        this.fetchDocument()
      }
    }
  }
</script>
